import { TCreateAlertRuleFields, TCreateAlertRuleResponse } from 'shared/types'
import { api } from '..'

export const createAlertRule = async (
  data?: TCreateAlertRuleFields,
): Promise<TCreateAlertRuleResponse> => {
  const { alertRuleId } = await api
    .post<TCreateAlertRuleResponse>('/v1/alert-rules', data)
    .then(({ data }) => data)

  return { alertRuleId }
}
